import { Storage } from "@ionic/storage";

export const storage = new Storage({
  name: "sing-and-speak-4-kids-storage"
});

await storage.create();
